export default "__VITE_ASSET__oAPkTrf2__"